// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/width.scss
// module id = EB8p
// module chunks = 43